module.exports = "https://cdn01.riselinkedu.com/assets/images/map.e07e807.png";